module.exports = __webpack_public_path__ + "static/media/arrowiosback.38702ada.svg";